import axios, { AxiosRequestHeaders } from "axios";
import { useAuthStore } from "../store";

const newCapTableApi = axios.create({
  baseURL: process.env.REACT_APP_NEW_CAPTABLE_API || "http://localhost:4000",
});

newCapTableApi.defaults.headers.post["Content-Type"] = "application/json";

newCapTableApi.interceptors.request.use((config) => {
  const companyId = useAuthStore.getState().companyId || "";
  const accesstoken =
    sessionStorage.getItem("accesstoken") || useAuthStore.getState().accessToken;
  if (accesstoken && !config.url?.endsWith("/login")) {
    (config.headers as AxiosRequestHeaders).AccessToken = accesstoken;
    (config.headers as AxiosRequestHeaders).companyId = companyId;
  }
  if (config.url === "exit") {
    delete (config.headers as AxiosRequestHeaders).AccessToken;
  }
  return config;
});

export default newCapTableApi;
